import React from 'react';
import { KIOSK_TAG } from '../Constants';
import _ from 'lodash';

class KioskTagging extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tag: '',
    };
    this.handleSelect = this.handleSelect.bind(this);
    this.handleTag = this.handleTag.bind(this);
  }

  handleSelect(tag) {
    this.setState({ tag });
  }

  handleTag() {
    const { onDone } = this.props;
    const { tag } = this.state;
    onDone(tag);
  }

  render() {
    let { onCancel, selectedHostInfoList } = this.props;
    let { tag } = this.state;

    return (
      <div style={{ width: 600 }}>
        <h1>Tagging {selectedHostInfoList.length} Kiosks</h1>
        <div className='pure-g' style={{ marginBottom: 20 }}>
          <div
            className={tag === KIOSK_TAG.NO_TAG ? 'pure-u-1 row tag-selected-row' : 'pure-u-1 row'}
            onClick={this.handleSelect.bind(this, KIOSK_TAG.NO_TAG)}
          >
            <i
              className='fa fa-2x fa-fw fa-tag color-aux'
              style={{ position: 'relative', top: 7 }}
            />
            No Tag
          </div>
          <div
            className={
              tag === KIOSK_TAG.PROD_TEST ? 'pure-u-1 row tag-selected-row' : 'pure-u-1 row'
            }
            onClick={this.handleSelect.bind(this, KIOSK_TAG.PROD_TEST)}
          >
            <i
              className='fa fa-2x fa-fw fa-tag color-success'
              style={{ position: 'relative', top: 7 }}
            />
            Prod Test (Demo/Support)
          </div>
          <div
            className={
              tag === KIOSK_TAG.CHECK_BEFORE_UPDATE
                ? 'pure-u-1 row tag-selected-row'
                : 'pure-u-1 row'
            }
            onClick={this.handleSelect.bind(this, KIOSK_TAG.CHECK_BEFORE_UPDATE)}
          >
            <i
              className='fa fa-2x fa-fw fa-tag color-primary'
              style={{ position: 'relative', top: 7 }}
            />
            Extenuating Circumstances. Check note before updating.
          </div>
          <div
            className={
              tag === KIOSK_TAG.EARLY_UPDATE ? 'pure-u-1 row tag-selected-row' : 'pure-u-1 row'
            }
            onClick={this.handleSelect.bind(this, KIOSK_TAG.EARLY_UPDATE)}
          >
            <i
              className='fa fa-2x fa-fw fa-tag color-accent'
              style={{ position: 'relative', top: 7 }}
            />
            Early Update - Update kiosks before the rest.
          </div>
          <div
            className={
              tag === KIOSK_TAG.TEMP_BETA ? 'pure-u-1 row tag-selected-row' : 'pure-u-1 row'
            }
            onClick={this.handleSelect.bind(this, KIOSK_TAG.TEMP_BETA)}
          >
            <i
              className='fa fa-2x fa-fw fa-tag color-deepskyblue'
              style={{ position: 'relative', top: 7 }}
            />
            Temp Beta
          </div>
          <div
            className={
              tag === KIOSK_TAG.DO_NOT_UPDATE ? 'pure-u-1 row tag-selected-row' : 'pure-u-1 row'
            }
            onClick={this.handleSelect.bind(this, KIOSK_TAG.DO_NOT_UPDATE)}
          >
            <i
              className='fa fa-2x fa-fw fa-tag color-danger'
              style={{ position: 'relative', top: 7 }}
            />
            Full Stop. Do Not Update.
          </div>
        </div>

        <div className='modalFooter pure-g' style={{ textAlign: 'right' }}>
          <div className='pure-u-5-24'></div>
          <div className='pure-u-1-4'>
            <button className='pure-button button-regular button-aux' onClick={onCancel}>
              Cancel
            </button>
          </div>
          <div className='pure-u-1-24'></div>
          <div className='pure-u-1-2'>
            <button className='pure-button button-regular button-accent' onClick={this.handleTag}>
              Tag Kiosks
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default KioskTagging;



// WEBPACK FOOTER //
// ./src/components/KioskTagging.js